import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider, localizePath, useLanguage } from './contexts/LanguageContext';
import Seo from './components/Seo';
import CookieBanner from './components/CookieBanner';
import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import GlobalPresence from './components/GlobalPresence';
import ServicesMinimal from './components/ServicesMinimal';
import EventsMinimal from './components/EventsMinimal';
import Confidentiality from './components/Confidentiality';
import ContactMinimal from './components/ContactMinimal';
import FooterMinimal from './components/FooterMinimal';
import ScrollToTop from './components/ScrollToTop';
import CPOPage from './pages/CPOPage';
import RiskAssessmentPage from './pages/RiskAssessmentPage';
import AdvanceCoordinationPage from './pages/AdvanceCoordinationPage';
import CCTV247Page from './pages/CCTV247Page';
import TrainingPage from './pages/TrainingPage';
import ArmoredVehiclesPage from './pages/ArmoredVehiclesPage';
import ConfidentialitePage from './pages/ConfidentialitePage';
import EventPage from './pages/EventPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import events from './data/events';
import './App.css';

function HomePage() {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App">
      <Header onScrollToContact={scrollToContact} />
      <main>
        <Hero onScrollToContact={scrollToContact} />
        <AboutSection />
        <GlobalPresence />
        <ServicesMinimal />
        <Confidentiality />
        <ContactMinimal ref={contactRef} />
        <EventsMinimal />
      </main>
      <FooterMinimal />
    </div>
  );
}

const pages = [
  ['/', HomePage],
  ['/cpo', CPOPage],
  ['/evaluation-risques', RiskAssessmentPage],
  ['/coordination-prealable', AdvanceCoordinationPage],
  ['/cctv-24-7', CCTV247Page],
  ['/formation', TrainingPage],
  ['/vehicules-blindes', ArmoredVehiclesPage],
  ['/confidentialite', ConfidentialitePage],
  ['/mentions-legales', MentionsLegalesPage],
  ...events.map((event) => [event.path, () => <EventPage event={event} />]),
];

// Adresse inconnue : retour à l'accueil, dans la langue de l'adresse demandée.
function NotFound() {
  const { language } = useLanguage();
  return <Navigate to={localizePath('/', language)} replace />;
}

function App() {
  return (
    <Router>
      <LanguageProvider>
        <ScrollToTop />
        <Seo />
        <Toaster position="top-right" theme="dark" />
        <CookieBanner />
        <Routes>
          {pages.map(([path, Page]) => (
            <Route key={path} path={path} element={<Page />} />
          ))}
          {pages.map(([path, Page]) => (
            <Route key={`en${path}`} path={localizePath(path, 'en')} element={<Page />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </LanguageProvider>
    </Router>
  );
}

export default App;
